import Immutable from 'immutable';

export const OptionState = Immutable.fromJS({
    conform:[],
    reserveType:[],
    reserveDate:[],
    reserveTime:[],
    gender:[{value:"M", label:"男"},{value:"F", label:"女"}],
    city:[],
    AREA_CODE:[],
    vaccine:[],
    loading:false,   
})

export const formDefault = {
    conformId:"",
    reserveType:"",
    reserveDate:"",
    reserveTimeId:"",
    PAT_NAME:"",
    PAT_IDNO:"",
    TEL_MOBILE:"",
    EMAIL:"",
    SEX:"",
    BIRTHDAY:null,
    OCC_COMP:"",
    OCC_TITLE:"",
    city:"", 
    AREA_CODE:"",
    ADDRESS:"",
    DOSAGE_COUNT:"",
    PRE_VACCINE_TYPE:"",
    PRE_VACCINE_DATE:null,
    loading:false
}

export const FormState = Immutable.fromJS(formDefault)

export const ResultState =  Immutable.fromJS({
    result:{}
})

export const ReserveHistoryState = Immutable.fromJS({
    search:{
        PAT_IDNO:"",
        TICKET_NO:"",
        TEL_MOBILE:"",
        loading:false
    },
    result:{}
})


